import { AlertTriangle } from "lucide-react";
import { useEffect } from "react";
import { useMemo, useState } from "react";
import { formatRelativeDate } from "../../utils/date";
import { useUserStore } from "../../contexts/userStore";

export function LicenseAlert({ unit, ...props }) {
   const [isLicenseEnabled, setIsLicenseEnabled] = useState(false);
   const [isLicenseValid, setIsLicenseValid] = useState(false);
   const [timeToInit, setTimeToInit] = useState(0);
   const [timeToExpire, setTimeToExpire] = useState(0);
   const { clientLicenses } = useUserStore();
   const license = clientLicenses.find(l => Number(l.id_condominium) === Number(unit));
   const startDate = license ? new Date(`${license.start_date}T00:00:00`) : null;
   const endDate = license ? new Date(`${license.end_date}T00:00:00`) : null;

   useEffect(() => {
      function updateState() {
         if (license) {
            const now = new Date();
            setIsLicenseEnabled(license.enabled);
            setIsLicenseValid(startDate <= now && endDate >= now);
            const timeToExpire = Math.floor((endDate - now));
            const timeToInit = Math.floor((now - startDate));
            setTimeToExpire(Math.max(timeToExpire, 0));
            setTimeToInit(Math.min(timeToInit, 0));
         } else {
            setIsLicenseEnabled(false);
            setIsLicenseValid(false);
            setTimeToInit(0);
            setTimeToExpire(0);
         }
      }
      updateState();
      const interval = setInterval(updateState, 1000 * 60);
      return () => clearInterval(interval);
   }, [license]);

   const alertText = useMemo(() => {
      if (!isLicenseValid && timeToExpire === 0) return "Licença expirada";
      if (!isLicenseEnabled) return "Licença desabilitada";
      return null;
   }, [isLicenseEnabled, isLicenseValid]);

   if (!license) {
      return;
   }

   if (alertText) {
      return (
         <div {...props}>
            <div className="flex flex-row items-center gap-2 alert alert-danger">
               <AlertTriangle size={16} />
               {!props.onlyIcon && <span className="leading-[1.1]!">{alertText}</span>}
            </div>
         </div>
      );
   }

   if (timeToInit < 0) {
      return (
         <div {...props}>
            <div className="flex flex-row items-center gap-2 alert alert-warning">
               <AlertTriangle size={16} />
               {!props.onlyIcon && <span className="leading-[1.1]!">A licença inicia em {formatRelativeDate(new Date(), startDate, { simple: true })}</span>}
            </div>
         </div>
      );
   }

   return (
      <div {...props}>
         {timeToExpire <= 30 * 24 * 60 * 60 * 1000 && (
            <div className="flex flex-row items-center gap-2 alert alert-warning">
               <AlertTriangle size={16} />
               {!props.onlyIcon && <span className="leading-[1.1]!">A licença expira em {formatRelativeDate(new Date(), endDate, { simple: true })}</span>}
            </div>
         )}
      </div>
   );
}